export default __webpack_public_path__ + "static/media/consequence-rating.66b35700.png";